import { memo, useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { createBlockRenderer } from './createBlockRenderer';
import { FallbackBlock } from './blocks/defaultRenderers';
import { UserMessage } from './UserMessage';
import { MessageContextDetails } from './MessageContextDetails';
import { useIsInternalUi } from './InternalUiContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function UserMessageContent({
  message,
  renderBlock,
  UserMessageWrapper
}) {
  const showMessageContext = useIsInternalUi();
  const textBlocks = message.blocks.filter(b => b.type === 'TEXT');
  const mediaBlocks = message.blocks.filter(b => b.type !== 'TEXT');
  const textContent = textBlocks.map((block, i) => /*#__PURE__*/_jsx("span", {
    "data-block-type": "text",
    children: block.text
  }, `t-${i}`));
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "end",
    gap: "200",
    inlineSize: "100%",
    children: [showMessageContext && message.messageContext && message.messageContext.entries.length > 0 && /*#__PURE__*/_jsx(MessageContextDetails, {
      context: message.messageContext
    }), mediaBlocks.length > 0 && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "200",
      maxInlineSize: "min(700px, 100%)",
      children: mediaBlocks.map((block, i) => renderBlock(block, `m-${i}`))
    }), textBlocks.length > 0 && (UserMessageWrapper ? /*#__PURE__*/_jsx(UserMessageWrapper, {
      message: message,
      children: textContent
    }) : /*#__PURE__*/_jsx(UserMessage, {
      children: textContent
    }))]
  });
}
function AssistantMessageContent({
  message,
  renderBlock
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: message.blocks.map((block, i) => renderBlock(block, i))
  });
}
function MessageViewInner({
  message,
  renderers,
  MessageWrapper,
  UserMessageWrapper
}) {
  const renderBlock = useMemo(() => createBlockRenderer(renderers, FallbackBlock, message), [renderers, message]);
  if (message.blocks.length === 0) return null;
  const content = message.role === 'USER' ? /*#__PURE__*/_jsx(UserMessageContent, {
    message: message,
    renderBlock: renderBlock,
    UserMessageWrapper: UserMessageWrapper
  }) : /*#__PURE__*/_jsx(AssistantMessageContent, {
    message: message,
    renderBlock: renderBlock
  });
  return /*#__PURE__*/_jsx("div", {
    "data-role": message.role,
    "data-message-id": message.id,
    children: MessageWrapper ? /*#__PURE__*/_jsx(MessageWrapper, {
      message: message,
      children: content
    }) : content
  });
}
export const MessageView = /*#__PURE__*/memo(MessageViewInner);